import { z } from "zod";
import { VisualMediaSchema } from "../Media";
import { RichTextSchema } from "../RichText";
import { ActionSchema } from "../Actions";
import { AnalyticsSchema } from "../../types";
export const ContentItemSchema = z.object({
    media: VisualMediaSchema,
    title: z.string().optional(),
    shortTitle: z.string().optional(),
    action: ActionSchema.optional(),
    analytics: AnalyticsSchema.optional(),
    description: RichTextSchema.optional(),
    publishedAt: z.string().optional(),
    category: z
        .object({
        machineName: z.string(),
        title: z.string(),
    })
        .optional(),
});
//# sourceMappingURL=index.js.map